import type { ServiceSignal } from '../../api/client'
import type { Channel, QueueItem } from '@rp/contracts'
import { STATUS_DETAIL_COPY } from './copy'

export const deriveChannelSignals = (channels: readonly Channel[], now: Date): readonly ServiceSignal[] => {
  const disconnected = channels.filter((channel) => channel.status === 'disconnected')
  if (disconnected.length === 0) return []
  return [
    {
      kind: 'channel_disconnected',
      detail: STATUS_DETAIL_COPY.disconnectedChannels(disconnected.map((channel) => channel.name)),
      at: now.toISOString(),
    },
  ]
}

export const deriveClassificationSignals = (items: readonly QueueItem[], now: Date): readonly ServiceSignal[] => {
  const failed = items.filter((item) => item.classification.status === 'failed')
  if (failed.length === 0) return []
  return [
    {
      kind: 'classification_degraded',
      detail: STATUS_DETAIL_COPY.failedClassification(failed.length),
      at: now.toISOString(),
    },
  ]
}
